"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgTemperatureHighFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.temperature-high_filled_svg__cls-1{display:none}')),
        React.createElement("g", { id: "temperature-high_filled_svg__transparent_box" },
            React.createElement("path", { className: "temperature-high_filled_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "temperature-high_filled_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "temperature-high_filled_svg__FILLED" },
            React.createElement("path", { d: "M14 17.26V6a4 4 0 00-8 0v11.45A6.64 6.64 0 003 23a7 7 0 1011-5.74zM10 4a2 2 0 012 2v2H8V6a2 2 0 012-2zM20 4h8v2h-8zM20 10h5v2h-5zM20 16h8v2h-8zM20 22h5v2h-5z" }))));
}
exports.default = SvgTemperatureHighFilled;
//# sourceMappingURL=TemperatureHighFilled.js.map